import * as React from 'react';
import { cn, Card, CardContent } from '@ai-content-hub/content-kit';
import { FileText } from 'lucide-react';
import { usePromptTranslations } from '../i18n';

export interface PromptCardProps {
    label?: string;
    labelOptional?: boolean;
    className?: string;
    children: React.ReactNode;
}

export const PromptCard: React.FC<PromptCardProps> = ({
    label,
    labelOptional = true,
    className,
    children,
}) => {
    // EAA-2031: heading and "(Optional)" follow the prompt locale instead of fixed English.
    const pt = usePromptTranslations();
    return (
    <Card className={cn('prompt-description-input rounded-none', className)}>
        <CardContent className="flex flex-col gap-4 px-4">
            <h3 className="text-sm font-semibold text-foreground tracking-tight flex items-center gap-2">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-primary/10 text-primary">
                    <FileText className="h-3.5 w-3.5" />
                </span>
                {label ?? pt.descriptionLabel}
                {labelOptional && (
                    <span className="text-muted-foreground font-normal text-xs ml-1">
                        {pt.optionalSuffix}
                    </span>
                )}
            </h3>
            {children}
        </CardContent>
    </Card>
    );
};
